export const BASE_URL = 'http://localhost:8080';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token'); // ou 'authToken' selon ton projet
  return {
    'Authorization': 'Basic ' + token,
    'Content-Type': 'application/json',
  };
};
